<template>
  <div>
    <login v-on:verifyEvent="verifyEvent"></login>
    <VerifyEvent v-on:goPlayer="goPlayer" v-if="isVerifyEvent"></VerifyEvent>
  </div>
</template>

<script>
import Login from "../components/Login";
import VerifyEvent from "../components/VerifyEvent";
import {mapState} from "vuex";

export default {
  name: "Login",
  data() {
    return {
      isVerifyEvent: false
    }
  },
  components: {
    'login': Login,
    VerifyEvent
  },
  computed: {
    ...mapState(['role'])
  },
  methods: {
    verifyEvent() {
      //this.$store.commit('updateIsLoading', false)
      this.isVerifyEvent = true
    },
    goPlayer(code) {
      this.$store.commit('updateIsLoading', true)
      this.isVerifyEvent = false
      this.role === 'graph' ? this.$router.push({path: `/dashboard`}) : this.$router.push({path: `/player/${code.toLowerCase().replace(/\s/g, "")}`})
    }
  },
  created() {
    this.$store.commit('updateIsLoading', false)
  }
}
</script>

<style scoped>

</style>